import QRCode from "qrcode";
import { ASSETS } from "@/data";

export const NAVY = "#0A1A4A";

const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.crossOrigin = "anonymous"; i.onload = () => res(i); i.onerror = rej; i.src = src; });

// Renders a branded QR (navy modules, logo in the centre) onto a canvas and returns it.
export async function renderBrandedQr({ url, size = 1024, dark = NAVY, light = "#FFFFFF", logo = true }) {
  const canvas = document.createElement("canvas");
  await QRCode.toCanvas(canvas, url, { errorCorrectionLevel: "H", width: size, margin: 2, color: { dark, light } });
  if (logo) {
    const ctx = canvas.getContext("2d");
    const box = Math.round(size * 0.24);
    const x = (size - box) / 2;
    ctx.fillStyle = light;
    const r = box * 0.12;
    ctx.beginPath(); ctx.roundRect(x, x, box, box, r); ctx.fill();
    try {
      const img = await loadImg(ASSETS.logo);
      const pad = box * 0.08;
      ctx.drawImage(img, x + pad, x + pad, box - pad * 2, box - pad * 2);
    } catch (e) { /* logo optional */ }
  }
  return canvas;
}

// Full printable poster: QR + title + caption + URL, as a canvas.
export async function renderQrPoster({ url, caption, size = 2048 }) {
  const qr = await renderBrandedQr({ url, size: Math.round(size * 0.78) });
  const W = size, H = Math.round(size * 1.28);
  const c = document.createElement("canvas"); c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#FFFFFF"; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = NAVY; ctx.fillRect(0, 0, W, Math.round(size * 0.16));
  ctx.fillStyle = "#FFFFFF"; ctx.textAlign = "center"; ctx.textBaseline = "middle";
  ctx.font = `800 ${Math.round(size * 0.062)}px "Manrope", "Liberation Sans", Arial, sans-serif`;
  ctx.fillText("Φυσική Επιλογή", W / 2, size * 0.065);
  ctx.font = `500 ${Math.round(size * 0.026)}px "JetBrains Mono", monospace`;
  ctx.fillStyle = "rgba(255,255,255,0.7)";
  ctx.fillText("ΦΡΟΝΤΙΣΤΗΡΙΑ ΜΕΣΗΣ ΕΚΠΑΙΔΕΥΣΗΣ", W / 2, size * 0.118);
  ctx.drawImage(qr, (W - qr.width) / 2, size * 0.2);
  ctx.fillStyle = NAVY;
  ctx.font = `700 ${Math.round(size * 0.05)}px "Manrope", "Liberation Sans", Arial, sans-serif`;
  ctx.fillText(caption, W / 2, size * 1.06);
  ctx.fillStyle = "#E63946";
  ctx.font = `500 ${Math.round(size * 0.03)}px "JetBrains Mono", monospace`;
  ctx.fillText(url.replace(/^https?:\/\//, ""), W / 2, size * 1.13);
  ctx.fillStyle = "#6B7280";
  ctx.font = `400 ${Math.round(size * 0.024)}px "Manrope", Arial, sans-serif`;
  ctx.fillText("25ης Μαρτίου 64, Πετρούπολη · 210 50 65 275", W / 2, size * 1.21);
  return c;
}

export const downloadCanvas = (canvas, filename) => {
  const a = document.createElement("a");
  a.href = canvas.toDataURL("image/png");
  a.download = filename;
  a.click();
};
